<main id="main">
    <!-- ======= Breadcrumbs ======= -->
    <div class="breadcrumbs" data-aos="fade-in">
        <div class="container">
            <h2 >Disclaimer</h2>
        </div>
    </div><!-- End Breadcrumbs -->

    <section id="testimonials1">
        <div class="container" data-aos="fade-up">

            <!-- <div class="section-title pb-0">
                <h2>Read Online</h2>
                <p  >Disclaimer</p><br>
            </div> -->
            <div class="row">
                <div class="col">
                <p>The information contained in this website is for general information purposes only. The 
                information is provided by www.sarvadhnya.com and while we endeavour to keep the information 
                up to date and correct, we make no representations or warranties of any kind, express or 
                implied, about the completeness, accuracy, reliability, suitability or availability with 
                respect to the website or the information, products, services, or related graphics 
                contained on the website for any purpose. Any reliance you place on such information is 
                therefore strictly at your own risk.</p>
                <p>In no event will we be liable for any loss or damage including without limitation, indirect 
                
                or consequential loss or damage, or any loss or damage whatsoever arising from loss of data 
                
                or profits arising out of, or in connection with, the use of this website.
                
                Through this website you are able to link to other websites which are not under the control 
                
                of www.sarvadhnya.com. We have no control over the nature, content and availability of those 
                
                sites. The inclusion of any links does not necessarily imply a recommendation or endorse 
                
                the views expressed within them.</p>
                <p>
                Every effort is made to keep the website up and runnisng smoothly. However, www.sarvadhnya.com 
                
                takes no responsibility for, and will not be liable for, the website being temporarily 
                
                unavailable due to technical issues beyond our control.</p>
                </div>
            </div>

        </div>
    </section>
</main>